import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";

export function ResubmitRequestButton(
  sampleRequestID,
  resubmitButtonDisabled,
  history
) {
  return (
    <Grid item>
      <Button
        size="small"
        variant="contained"
        disabled={resubmitButtonDisabled}
        sx={{
          padding: "10px 20px",
          mr: "20px",
          fontSize: "14px",
          backgroundColor: "#c7ab79",
          //   display: resubmitButtonDisabled && "none",
        }}
        onClick={() => history(`/resubmit/${sampleRequestID}`)}
      >
        Resubmit Request
      </Button>
    </Grid>
  );
}
